export default __webpack_public_path__ + "static/media/easy_to_begin.1be3d00e.PNG";